// packages/eden-style-constants/src/modes.js
import { sendUpdate } from "@churchofjesuschrist/eden-appearance";
var modeStyles = {};
modeStyles.light = {};
modeStyles.dark = {};
var modeCssVariableRef = {};
var setStyleConstant = (name, { light, dark, prefix = "--", noDuplicateCheck }) => {
  const combinedName = prefix + name;
  const cssVarReferenceWithDefault = `var(${combinedName}, ${light})`;
  if (modeCssVariableRef[combinedName] !== void 0 && modeCssVariableRef[combinedName] !== cssVarReferenceWithDefault && !noDuplicateCheck) {
    console.warn(
      `Duplicate variable name ${combinedName}.
Old Value: ${modeCssVariableRef[combinedName]}
New Value: ${cssVarReferenceWithDefault}`
    );
  }
  modeCssVariableRef[combinedName] = cssVarReferenceWithDefault;
  light ? modeStyles.light[combinedName] = light : console.warn(`No \`light\` value set for ${name}`);
  dark ? modeStyles.dark[combinedName] = dark : console.warn(`No \`dark\` value set for ${name}`);
  sendUpdate(combinedName, { light, dark });
  return cssVarReferenceWithDefault;
};
var setAppearanceConstant = (name, { light, dark, prefix = "project" }) => {
  if (!["project", "eden"].includes(prefix)) {
    console.warn(
      "setAppearanceConstant only allows a prefix of `project` or `eden`, you provided:",
      prefix
    );
    return;
  } else {
    prefix = "--" + prefix + "-";
  }
  return setStyleConstant(name, { light, dark, prefix });
};
var setAppearanceConstantGlobal = (name, { light, dark }) => setStyleConstant(name, { light, dark, prefix: "--" });
var getAppearanceConstant = (modeStyleResult) => {
  const extractedName = modeStyleResult.match(/--[\w-]+/)[0];
  if (!modeCssVariableRef[extractedName]) {
    console.warn(`No appearance style found for ${extractedName}`);
  }
  return {
    name: extractedName,
    light: modeStyles.light[extractedName],
    dark: modeStyles.dark[extractedName]
  };
};
var setAppearanceConstantLocal = (name, { light, dark, prefix = "project" }) => [
  ({
    theme: { edenAppearanceMode: mode } = { edenAppearanceMode: "light" }
  }) => {
    if (!dark) console.warn(`No \`dark\` value set for ${name}`);
    const darkCSS = `--${prefix}-${name} :  ${dark};`;
    let css = "";
    if (mode === "dark") css = darkCSS;
    if (mode === "os") {
      css = `@media (prefers-color-scheme: dark) {
          & { ${darkCSS} }
        }`;
    }
    return css;
  },
  () => {
    if (!light) console.warn(`No \`light\` value set for ${name}`);
    return `var(--${prefix}-${name}, ${light})`;
  }
];
export {
  getAppearanceConstant,
  setAppearanceConstant,
  setAppearanceConstantGlobal,
  setAppearanceConstantLocal
};
